import Scanner from './svg/Scanner.svg'

export default Scanner
